import {
    ChangeDetectionStrategy,
    Component,
    HostListener,
    TemplateRef,
    ViewEncapsulation,
    input,
    computed,
    output,
    inject,
} from '@angular/core';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { ISectionCardData } from '@fi-shared/fi-section-card/fi-section-card';
import { FiChecklistSectionTypes } from '@fi-shared/checklist';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-section-card',
    templateUrl: './fi-section-card.component.html',
    styleUrls: ['./fi-section-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'fi-section-card',
        '[class.mobile]': 'isMobilePhone',
        '[class.has-action-button]': 'isEditButtonShown() || isOptionActionShown()',
    },
    standalone: false,
})
export class FiSectionCardComponent {
    public contentCardData = input.required<ISectionCardData>();
    public isEditButtonShown = input<boolean>(false);
    public isOptionActionShown = input<boolean>(true);
    public isTooltipShown = input<boolean>();
    public tooltipText = input<string>();
    public tooltipClass = input<string | string[]>();
    public tooltipContentRef = input<TemplateRef<unknown>>();
    public cardNumber = input<number>();
    public editButtonClick = output<void>();

    private detectDevicesService = inject(DetectDevicesService);

    protected get isMobilePhone(): boolean {
        return this.detectDevicesService.isMobilePhone();
    }

    @HostListener('click') cardClick(): void {
        this.contentCardData()?.onClick?.();
    }

    protected actionTooltipClass = computed<string>(() => {
        const tooltipClass = this.tooltipClass();
        if (!isDefined(tooltipClass)) {
            return 'fi-rounded-white-tooltip';
        }
        return 'fi-rounded-white-tooltip ' + (Array.isArray(tooltipClass) ? tooltipClass.join(' ') : tooltipClass);
    });

    protected cardIconClass = computed<string>(() => {
        return [
            FiChecklistSectionTypes.ComplianceThreshold,
            FiChecklistSectionTypes.Settings,
            FiChecklistSectionTypes.QRCodes,
        ].includes(this.contentCardData()?.id)
            ? 'fa-pencil'
            : 'fa-angle-right';
    });

    protected onEditButtonClick($event: MouseEvent): void {
        $event.stopPropagation();
        this.editButtonClick.emit();
    }

    protected readonly FiInfoIconMode = FiInfoIconMode;
}
